// @ts-nocheck
import { Component, Input, inject } from '@angular/core';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { InputTextCondensedComponent } from '../input-text-condensed/input-text-condensed.component';
import { InputTextComponent } from '../input-text/input-text.component';
import { SelectTreeService } from '../select-tree/select-tree.service';

@Component({
  selector: 'lbca-select-tree-condensed',
  templateUrl: './select-tree-condensed.component.html',
  imports: [InputTextCondensedComponent, InputTextComponent],
})
export class SelectTreeCondensedComponent {
  private selectTreeService = inject(SelectTreeService);
  private dynamicFormService = inject(DynamicFormService);

  public checkedItens: any = [];
  private fieldItem: any;
  public itemLabel!: string;

  @Input() set label(val) {
    this.itemLabel = val;
  }
  @Input() set field(val) {
    this.fieldItem = val;
  }

  @Input() set value(val: any) {
    setTimeout(() => {
      if (val) this.fillBreadcrumb(val);
      else {
        this.checkedItens = [];
      }
    }, 1000);
  }

  public cardInfo: any;
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }

  private async fillBreadcrumb(id: string = ''): Promise<void> {
    const flowId = this.dynamicFormService.formControlStructure?.formMetadata?.flowId;

    this.selectTreeService.breadcrumbEntity(this.fieldItem.breadcrumbEntity, id, flowId).subscribe(
      (resp: any): void => {
        if (resp && Array.isArray(resp)) {
          this.checkedItens = resp.map((item) => item.label).join('/');
        } else {
          this.checkedItens = [];
        }
      },
      (error: any): void => {
        console.error(error);
      }
    );
  }
}
